<template>
  <div class="mapui-wrapper">
    <div class="center">
      <div class="flex flex-column zoom-map-controls">
        <div class="rectangle my-4">
          <v-btn icon @click="plusZoom" class="secondary--text">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-divider></v-divider>
          <v-btn @click="minusZoom" icon class="secondary--text">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="flex flex-column">
        <v-btn
          height="35"
          width="35"
          icon
          color="grey darken-3"
          elevation="2"
          small
          :class="showSatelliteMap ? 'activeSatelliteMap' : ''"
          class="mb-2 white"
          @click="toggleMap"
        >
          <SvgIcon
            width="23"
            height="23"
            class="secondary--text"
            iconType="icon_switch_maps"
          />
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { SvgIcon } from '@leapsight/styleguide'
import { mapActions, mapGetters } from 'vuex'
import { UiHelpers } from '@/helpers/mainExports'
export default {
  components: {
    SvgIcon
  },
  data() {
    return {
      userFullName: '',
      showLayersOptions: false,
      showSatelliteMap: false,
      toolbarAppBoxLoading: false,
      services: [],
      mapRef: {}
    }
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user) {
      this.userFullName = `${user.name} ${user.last_name} `
    }
  },
  methods: {
    ...mapActions('uiState', ['toggleMapLayer']),
    plusZoom() {
      this.map.setZoom(this.map.getZoom() + 1)
    },
    minusZoom() {
      this.map.setZoom(this.map.getZoom() - 1)
    },
    toggleMap() {
      this.showSatelliteMap = !this.showSatelliteMap
      if (this.map.getMapTypeId() == 'roadmap') {
        this.map.setMapTypeId('hybrid')
      } else this.map.setMapTypeId('roadmap')
    }
  },
  computed: {
    ...mapGetters('mapState', ['map']),
    ...mapGetters(['toolbarAppBoxState']),
    mapState() {
      return this.map
    }
  }
}
</script>

<style scoped>
.mapui-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-right: 16px;
}
.center,
.bottom {
  position: absolute;
  z-index: 2;
}

.rectangle {
  width: 35px;
  height: 70px;
  border-radius: 22.5px;
  box-shadow: 0 2px 4px 0 var(--shadow-3-dark);
  background-color: #ffffff;
}
.zoom-map-controls .v-divider {
  max-width: 60%;
  margin: auto;
}
.v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before {
  opacity: 0;
}

.center {
  top: 50%;
  transform: translateY(-50%);
  max-width: 36px;
}
.bottom {
  bottom: 36px;
  max-width: 36px;
}

.activeSatelliteMap {
  border: 2px solid var(--dark-hot-pink) !important;
}
</style>
